/* Classes de messages — EM-01 (Bible §50 · locked #—/§40).
   Four classes with separate rules, enforced at the sending layer and not
   only on screen. Unsubscribing from marketing never disables gift or
   account mail; a reminder describes an existing benefit or it doesn’t ship. */
import { useNavigate } from 'react-router-dom'
import { Button, ListRow, Note, Pill } from '@/ui'
import { MOMENTS } from '@/lib/campaign'
import { Obligatoire, Retour } from './parts'

/* the moment this class serves, named by the one source (D-65) */
const PLUS_TARD = MOMENTS.find(m => m.id === 'apres')?.title ?? 'Plus tard, par e-mail'

/* Batch 14 · D-69 ② adds « Retour »: the class of the one message that invites
   a customer back when her participation window reopens. It is a preference,
   not marketing — it describes a benefit that already exists — and it is the
   only class with a single message, so the row goes straight to it. */
const CLASSES = [
  { id: 'trans', name: 'Transactionnel', meta: 'cadeau émis, lien de connexion, sécurité — toujours envoyé, zéro promotion', tag: 'obligatoire' as const, go: null },
  { id: 'rappel', name: 'Rappel utile', meta: 'expiration, validité, prochaine étape — préférence dédiée', tag: 'preference' as const, go: null },
  { id: 'retour', name: 'Retour', meta: '« Revenez jouer » — envoyé le jour où la fenêtre du client se rouvre, une fois, jamais deux', tag: 'preference' as const, go: '/messages/revenez-jouer' },
  { id: 'avis', name: 'Invitation à donner un avis', meta: `« ${PLUS_TARD} » — finalité et base légale propres`, tag: 'preference' as const, go: null },
  { id: 'marketing', name: 'Marketing', meta: 'offres, actualités — consentement préalable + désinscription', tag: 'consentement' as const, go: null },
]

export default function Classes() {
  const nav = useNavigate()
  return (
    <div style={{ display: 'grid', gap: 16, maxWidth: 780 }}>
      <Retour />
      <h2 className="t-page" style={{ margin: 0 }}>Classes de messages</h2>

      <Note tone="ok">
        Les messages liés au cadeau partent seuls. Ceux qui <b>font revenir</b> — rappel après
        la visite, relance avant expiration — sont les plus rentables du produit&nbsp;: c’est
        là que se gagne une visite de plus par client.
      </Note>

      <section>
        {CLASSES.map(c => (
          <ListRow key={c.id} title={c.name} meta={c.meta}
            end={<span style={{ display: 'flex', gap: 10, alignItems: 'center' }}>
              {c.tag === 'obligatoire' ? <Obligatoire />
                : c.tag === 'preference' ? <Pill tone="ok">préférence</Pill>
                : <Pill tone="warn">consentement</Pill>}
              {c.go && <Button size="sm" variant="quiet" onClick={() => nav(c.go!)}>Régler</Button>}
            </span>} />
        ))}
      </section>

      <Note tone="candour">
        La séparation vit dans l’envoi, pas seulement dans l’interface&nbsp;: chaque envoi
        vérifie classe, consentement, suppression, fréquence, expéditeur et établissements concernés.
      </Note>
    </div>
  )
}
